import useFilterStore from '../zustandStore/useFilterStore';
import PropTypes from 'prop-types';
import StyledTextField from 'components/commons/StyledTextField';
import { Stack, Typography } from '@mui/material';

function TextFieldFilter(props) {
    const setFilters = useFilterStore(state => state.setFilters);
    const isDefault = useFilterStore(state => state.isDefaultFilterValue);
    const filters = useFilterStore(state => state.filters[props.comparableType]?.[props.attrName]);

    const handleChange = (inputValue) => {
        setFilters(props.comparableType, { [props.attrName]: inputValue.value });
    };
    return (
        <>
            <Stack spacing={2} mb={2}>
                <Typography variant="text1" gutterBottom mb={1}>{props.title}</Typography>
            </Stack>
            <Stack spacing={2} mb={2}>
                <Typography variant="headerSmall" gutterBottom mb={1}>{props.subTitle}</Typography>
            </Stack>
            <StyledTextField
                onChange={(event) => handleChange({ value: event.target.value })}
                inputProps={{
                    maxLength: props.maxLength,
                    readOnly: props.isInputReadOnly,
                    value: filters,
                }}
                label={props.label}
                size="small"
                isHighlighted={!isDefault(props.comparableType, props.attrName, filters)}
                sx={{
                    width: '100%',
                }}
            />
        </>
    );
}

TextFieldFilter.propTypes = {
    label: PropTypes.string.isRequired,
    comparableType: PropTypes.string.isRequired,
    attrName: PropTypes.string.isRequired,
    errorMessage: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    isInputReadOnly: PropTypes.bool,
    maxLength: PropTypes.number,
};
export default TextFieldFilter;